import { Autocomplete, Box, Chip, TextField } from '@mui/material'
import React, { useCallback } from 'react'
import { useStyles } from './style'

export const DomainInput = ({ domains, setDomains, placeholder, id, onEdit, label }) => {
  const classes = useStyles()

  const removeDomain = (tag) => {
    onEdit()
    setDomains((state) => state.filter((item) => item !== tag))
  }

  const updateDomain = useCallback(
    (event) => {
      const data = event.target.value
      if (!data) return

      const emailDomains = data
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter((value) => value && !domains.includes(value))

      setDomains((state) => [...state, ...emailDomains])
      onEdit()
    },
    [domains, setDomains, onEdit]
  )

  return (
    <Box>
      <Autocomplete
        multiple
        data-test={`${id}-input}`}
        options={[]}
        value={domains}
        freeSolo
        fullWidth
        onChange={(event) => updateDomain(event)}
        renderTags={(value) =>
          value.map((option, index) => {
            return (
              <Chip
                className={classes.domains}
                key={index}
                label={option}
                onDelete={() => removeDomain(option)}
              />
            )
          })}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
          />
        )}
      />
    </Box>
  )
}
